export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14723.b0983f4f.jpg";